import React from 'react'
import ReactDOM from 'react-dom/client'
import { App } from './App'
import './index.css'
import { registerServiceWorker } from './sw-register'
// Importar utilitários de manutenção para desenvolvimento
import './lib/maintenance-utils'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)

// Registrar o service worker
registerServiceWorker()
